module.exports = __webpack_public_path__ + "static/media/slumswaraj.63c3c766.png";